import { CustomState, State } from '../../../types'

export const SET_CURRENT_EMAIL = 'custom//SET_CURRENT_EMAIL'
export const SET_CHECKBOX_DATA = 'custom//SET_CHECKBOX_DATA'
export const SET_FIRST_TRACKED = 'custom//SET_FIRST_TRACKED'

export interface SetCurrentEmailAction {
  type: typeof SET_CURRENT_EMAIL
  payload: string
}

export interface SetCheckboxDataAction {
  type: typeof SET_CHECKBOX_DATA
  payload: string
}

export interface SetFirstTrackedAction {
  type: typeof SET_FIRST_TRACKED
  payload: boolean
}

export type CustomAction =
  | SetCurrentEmailAction
  | SetCheckboxDataAction
  | SetFirstTrackedAction

export function setCurrentEmail(data: string): SetCurrentEmailAction {
  return { type: SET_CURRENT_EMAIL, payload: data }
}

export function setCheckboxData(data: string): SetCheckboxDataAction {
  return { type: SET_CHECKBOX_DATA, payload: data }
}

export function setFirstTracked(data: boolean): SetFirstTrackedAction {
  return { type: SET_FIRST_TRACKED, payload: data }
}

export function getCheckboxData(store: State) {
  return store.custom.data.checkboxData
}

export function getCurrentEmail(store: State) {
  return store.custom.data.currentEmail
}

export function getFirstTracked(store: State) {
  return store.custom.data.firstTracked
}

const initialState: CustomState = {
  data: {
    firstTracked: false,
    currentEmail: '',
    checkboxData: '',
  },
}

export default function customReducer(
  state: CustomState = initialState,
  action: CustomAction
): CustomState {
  switch (action.type) {
    case SET_CURRENT_EMAIL:
      return {
        ...state,
        data: {
          ...state.data,
          currentEmail: action.payload,
        },
      }

    case SET_FIRST_TRACKED:
      return {
        ...state,
        data: {
          ...state.data,
          firstTracked: action.payload,
        },
      }

    case SET_CHECKBOX_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          checkboxData: action.payload,
        },
      }

    default:
      return state
  }
}
